import * as React from 'react';
import BlogItem from "@components/Blog/Item";
import { connect } from 'react-redux';
import { StoreState, Blog, PieceSlider } from '@store/index';
import { withRouter, Redirect, RouteComponentProps } from 'react-router-dom';
import { Helmet } from "react-helmet";

interface OwnProps extends RouteComponentProps<{item: string}> { }
interface StateProps { 
    blog?: Blog;
}
type Props = OwnProps & StateProps;

const BlogItemContainer: React.SFC<Props> = (props: Props) => {
    const { blog } = props;

    if (!blog) {
        return <Redirect
            to={{
                pathname: "/blog",
                state: { from: props.location }
            }}
        />
    }
    const title = blog.name + ' - Blog | Full Stack Web Developer, Artificial Intelligence Specialist';
    const url = process.env.REACT_APP_URL + props.location.pathname;
    const sliderPiece = blog.pieces.find((piece) => 'slider' === piece.type) as PieceSlider;

    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={blog.description} />

                <meta name="og:title" content={title} />
                <meta name="og:description" content={blog.description} />
                <meta name="og:url" content={url} />
                {
                    sliderPiece && sliderPiece.images && sliderPiece.images
                        .reverse().map((image, index) => (<meta key={`image-${index}`} name="og:image" content={image.url} />))
                }
                <meta name="og:image" content={blog.cover} />
            </Helmet>
            <BlogItem blog={blog} />
        </>
    );
}

export default connect<StateProps, {}, OwnProps>(
    (state: StoreState, props: OwnProps) => (
        { blog: state.blogs.find((blog: Blog) => blog.slug === props.match.params.item) }
    )
)(withRouter(BlogItemContainer));



// WEBPACK FOOTER //
// ./src/containers/Blog/Item/index.tsx